import { useMutation } from '@tanstack/react-query';

import { AuthAPI } from '../services/auth.service';
import { TVerifyGoogleLoginRequestSchema } from '../schema/login.schema';

export const useVerifyLogin = () => {
  return useMutation({
    mutationFn: (verifyLoginRequest: TVerifyGoogleLoginRequestSchema) =>
      AuthAPI.verifyLogin(verifyLoginRequest),
  });
};
